<template lang="html">
  <v-container fluid class="px-sm-10">
    <v-row>
      <v-col cols="auto" class="headline">Detailed Report</v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card>
          <base-items class="d-none" storeModule="payments" :filter="paymentsFilter" @items="items = $event" @state="state = $event"></base-items>
          <v-card-text>
            <v-row>
              <v-col sm="12" md="auto">
                <v-form ref="form" v-model="valid">
                  <date-input
                    v-model="dateFrom"
                    label="Date from"
                    :max="today"
                    :clearable="false"
                  ></date-input>
                  <date-input
                    v-model="dateTo"
                    label="Date to"
                    :max="today"
                    :rules="[validDateTo]"
                    :placeholder="dateFrom"
                  ></date-input>
                </v-form>
                <v-btn class="mt-6" @click="print" color="primary" :disabled="state.loading">Print</v-btn>
              </v-col>
              <v-col cols="12" md="6">
                <template v-if="valid">
                  <div v-if="state.loading" class="">
                    <v-progress-circular color="primary" indeterminate></v-progress-circular>
                  </div>
                  <div v-else ref="print">
                    <div class="detailed-report-container text--disabled">
                      <detailed-report :payments="items" :date="!!dateTo ? dateFrom +' - '+ dateTo : dateFrom" :org-name="overview.org_name" :org-number="overview.org_number"></detailed-report>
                    </div>
                  </div>
                </template>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import DetailedReport from '../components/DetailedReport.vue'
import {DateInput} from 'dync-datetime';
import {BaseItems} from 'dync-baseitem'
import moment from 'moment-timezone'

export default {
  data () {
    return {
      datemenu: false,
      today: moment().format('YYYY-MM-DD'),
      dateFrom: moment().format('YYYY-MM-DD'),
      dateTo: null,
      validDateTo: (v) => !v || v >= this.dateFrom || 'Date to must be after date from',
      items: [],
      state: {},
      valid: true
    };
  },
  watch: {
    dateFrom() {
      if (this.$refs.form) {
        this.$refs.form.validate();
      }
    }
  },
  computed: {
    paymentsFilter () {
      var dateTo = this.dateTo || this.dateFrom;
      var result = {
        greaterThan: [
          ['dateCreated', moment(this.dateFrom).subtract(1, 'days').endOf('day').tz('UTC').format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z']
        ],
        lessThan: [
          ['dateCreated', moment(dateTo).add(1, 'days').startOf('day').tz('UTC').format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z']
        ],
        keyValueIn: [
          ['status', ['PAID', 'REDEEMED']]
        ]
      };
      return result;
    },
    overview () {
      const items = this.$store.getters['overviews/items'];
      return items.length > 0 ? items[0] : {};
    }
  },
  methods: {
    print () {
      var newWindow = window.open();
      // Copy head for styling and print container for content
      newWindow.document.write(document.head.innerHTML + '\n\n' + this.$refs.print.innerHTML);
      // Poll for page to render before starting print
      var intervalId = setInterval(() => {
        if (newWindow.document.documentElement.offsetHeight > 0) {
          clearInterval(intervalId);
          setTimeout(function () {
            newWindow.print();
            newWindow.close();
          }, 1000);
        }
      }, 100);
    }
  },
  components: {
    DetailedReport,
    BaseItems,
    DateInput
  }
}
</script>

<style lang="css">
.detailed-report-container {
  max-width: 40rem;
  border: 1px solid currentcolor;
  padding: 1rem;
}
@media print {
  .detailed-report-container {
    border-color: transparent;
    margin: 0 auto;
  }
  .detailed-report {
    font-family: sans-serif;
  }
}
</style>
